import {IShopRating} from "@connox/typescript-library";
import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import styled from "styled-components";
import {reviewTitle} from "../../theme";

const ReviewTitle = styled.strong`
  font-family: ${reviewTitle};
  margin-top: 0;
  font-size: 1em;
  font-weight: 600;
  line-height: 1.6;
  display: block;
  margin-bottom: 0.2em;
`;

interface IShopRatingProps extends WithTranslation {
  comments: IShopRating[];
  loadMoreClicked: () => void;
  buttonDisabled: boolean;
}

const ShopRatingComments = (props: IShopRatingProps) => {
  const {t, loadMoreClicked, comments, buttonDisabled} = props;
  const commentComponents = comments.map((comment, index) => {
    const {content, created, customerName, itemName, ownerRemark, rating, subject, translated} = comment;

    return (
      <div key={`comment${index}`} className={"text"} style={{marginBottom: "2rem"}}>
        <div>
          <ReviewTitle>{subject}</ReviewTitle>
          <p>
            <span
              className={"sprite sprite-link sprite-stars-small-" + rating * 2}
              itemProp="reviewRating"
              itemType="http://schema.org/Rating"
            >
              {t("{{rating}} von 5 Sternen", {rating})}
              <meta itemProp="ratingValue" content={rating.toString()} />
            </span>{" "}
            {created},
            <meta itemProp="datePublished" content={created} />
            <span itemProp="author"> {customerName}</span>
            {", "}
            <span>
              <span>{itemName}</span>
            </span>
          </p>
        </div>
        <div className="description">
          {translated && (
            <p className="auto-translation-hint lightgrey">{t("Automatisch übersetzt aus dem Deutschen")}</p>
          )}
          <p>{content}</p>
          {ownerRemark && (
            <>
              <br />
              <p>
                <em>{t("Kommentar vom Connox-Team:")}</em>
                <br />
                {ownerRemark}
              </p>
            </>
          )}
        </div>
        <br className="clear" />
      </div>
    );
  });

  return (
    <div>
      {commentComponents}
      <div style={{textAlign: "center"}}>
        {!buttonDisabled && (
          <button
            id={"loadMoreButton"}
            className={"button button-white button-large button-wide ga-bottom-filter-button"}
            onClick={loadMoreClicked}
            type={"button"}
          >
            {t("Weitere Bewertungen anzeigen")}
          </button>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(ShopRatingComments);
